import React from "react";
import styled from 'styled-components';
import { colours } from '../Styles';

function Showcase(props) {
  const { dark } = colours;
    const Showcase = styled.div`
    height: calc(100vh);
    width: 100vw;
    overflow: hidden;
    background: ${dark};
    z-index: 1;

    @media only screen and (max-width: 600px) {
        height: calc(100vh);
    }
    `;
  return (
    <Showcase>
        {props.children}
    </Showcase>
  );
}

export default Showcase;
